<template>
	

	<div class="">
		<app-header/>
		
		<div class="content container">
			<h2>Terms</h2>

			<img src="https://specials-images.forbesimg.com/imageserve/687488386/960x0.jpg?fit=scale"  class="float-left mr-4 mb-4" style=" max-width: 50vw">

			{{$t('terms.text')}}
		</div>
		
		<app-footer/>

	</div>
</template>


<script>
import Vue from "vue";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter
  },
  data: function() {
    return {};
  },
  methods: {}
});
</script>


<style lang="scss">
</style>
